import React from 'react';
import { 
    NavContainer, 
    NavLogo, 
    MobileIcon, 
    NavMenu, 
    NavItem,
    FaIcon, 
    NavLinks 
} from './NavbarStyles';
import logo from '../../assets/images/logo.svg'; // Corrected path to logo.png

const Navbar = ({ toggle }) => {
    return (
        <NavContainer>
            <NavLogo to='/'>
                <img src={logo} alt="Helix Logo" style={{ height: '50px' }} />  
            </NavLogo>
            <MobileIcon onClick={toggle}>
                <FaIcon />
            </MobileIcon>
            <NavMenu>
                <NavItem>
                    <NavLinks to='services' spy={true} smooth={true} duration={500}>
                        Services
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to='portfolio' spy={true} smooth={true} duration={500}>
                        Portfolio
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to='about' spy={true} smooth={true} duration={500}>
                        About us
                    </NavLinks>
                </NavItem>
                <NavItem>
                    <NavLinks to='contact' spy={true} smooth={true} duration={500}>
                        Contact Us
                    </NavLinks>
                </NavItem>
            </NavMenu>
        </NavContainer>
    );
};

export default Navbar;
